import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api, apiUrls } from '@/lib/apiClient';
import type { AlertSettings, SaveResponse } from '@/types/model.types';

/** Replaces AlertsService. */
export function useAlertSettings() {
  return useQuery({
    queryKey: ['alert-settings'],
    queryFn: () =>
      api.get<AlertSettings>(apiUrls.alertSettings, { operation: 'retrieving alert settings' }),
  });
}

export function useSaveAlertSettings() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (alertSettings: AlertSettings) =>
      api.put<SaveResponse>(apiUrls.alertSettings, {
        operation: 'saving alert settings',
        body: alertSettings,
      }),
    onSuccess: (_data, alertSettings) => {
      queryClient.setQueryData(['alert-settings'], alertSettings);
    },
  });
}
